import { createFileRoute, redirect } from "@tanstack/react-router";
import { navItem } from "@alm/policy";
import { optionalOneOf, optionalString, optionalSearch } from "@/lib/search";
import { routeAllowed } from "@/lib/policy";
import { StaffPage } from "@/routes/_authenticated/_administration/employees/-components/staff-page";

/** HR opens on the register; someone who may read HR but not the roster gets the compliance
 * overview instead of a refusal. */
export const Route = createFileRoute("/_authenticated/_workforce/hr/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { q?: string; role?: string; showing?: "inactive" } => ({
    q: optionalSearch(search.q),
    role: optionalString(search.role) || undefined,
    showing: optionalOneOf(["inactive"], search.showing),
  }),
  beforeLoad: ({ context }) => {
    if (!context.me || routeAllowed(context.me, navItem("user-management"))) return;
    throw redirect({ to: "/hr/overview", replace: true });
  },
  component: StaffPage,
});
